import { render, staticRenderFns } from "./RadioCustomList.vue?vue&type=template&id=12059926&scoped=true&"
import script from "./RadioCustomList.vue?vue&type=script&lang=js&"
export * from "./RadioCustomList.vue?vue&type=script&lang=js&"
import style0 from "./RadioCustomList.vue?vue&type=style&index=0&id=12059926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12059926",
  null
  
)

export default component.exports